import { render } from "./ResetOTP.vue?vue&type=template&id=94f6e1f8"
import script from "./ResetOTP.vue?vue&type=script&lang=js"
export * from "./ResetOTP.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/dmsfrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__